// import React from 'react';
// import logo from './logo.svg';
import './App.css';
import { Route, Router } from 'react-router-dom';
import Pages from './components/Routes';

import { createBrowserHistory } from "history";
const history = createBrowserHistory();

function App() {

  return (
    <div className="App">
    <Router history={history}>
      <Route component={Pages} />
    </Router>
  </div>
    )

  // return (
  //   <div className="App">
  //     <header className="App-header">
  //       <img src={logo} className="App-logo" alt="logo" />
  //       <p>
  //         Edit <code>src/App.tsx</code> and save to reload.
  //       </p>
  //       <a
  //         className="App-link"
  //         href="https://reactjs.org"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         Learn React
  //       </a>
  //     </header>
  //   </div>
  // );
}

export default App;
